import template from 'template/sign_up/form/2fa/google_authenticator';
import SecondFactorLoginRepository from "../../repository/second_factor_login_repository";
import SecondFactorLoginModel from "../../model/second_factor_login_model";
import BaseFormComponent from "../../../../common/component/base_form";

export default class GoogleAuthenticatorComponent extends BaseFormComponent {

    initRepository() {
        this.repository = new SecondFactorLoginRepository();
    }

    makeNewModel() {
        let model = new SecondFactorLoginModel();
        model.provider = 'ga';
        model.cluster = this.props.cluster;

        return model;
    }

    onSave(model) {
        this.props.onSuccess(model);
    }

    onKeyPress(event) {
        if (event.charCode === 13) {
            this.onSubmit();
        }
    }

    render() {
        return template.bind(this)();
    }

}